const variable =
  process.env.REACT_APP_ENV === undefined
    ? process.env.NODE_ENV
    : process.env.REACT_APP_ENV;
export const env =
  variable === 'development'
    ? 'dev'
    : variable === 'production'
    ? 'prod'
    : variable;
export const server =
    env === 'uat_cn'
        ? 'https://ahf6hby5q5.execute-api.cn-north-1.amazonaws.com.cn/UAT'
        : env === 'wework_cn'
            ? 'https://ne0fanmrjb.execute-api.cn-north-1.amazonaws.com.cn/wework_v3'
            : env === 'wework'
                ? 'https://api.packagex.app/wework_v3'
                : env === 'pxinventory'
                    ? 'https://api.packagex.app/v1'
                    : env
                        ? `https://api.packagex.app/${env}`
                        : 'https://api.packagex.app/dev';
export const chineseAuth =
    env === 'qa_cn'
        ? 'https://authqa.packagex.app'
        : env === 'dev_cn'
            ? 'https://authdev.packagex.app'
            : env === 'uat_cn'
                ? 'https://auth-uat.packagexai.cn'
                : env === 'wework_cn'
                    ? 'https://auth-wework.packagexai.cn'
                    : 'https://authdev.packagex.app';
